import React from 'react';
import { Field, reduxForm, getFormValues, reset } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Button, TextInput, MultiSelect, H5 } from '../../components/index.js';
import RichTextEditor from '../../components/richText/RichTextEditor.js';
import usertypes from '../../constants/json/usertypes/usertypes.json';
import { createServiceAction } from '../../util/actionHelper.js';

export class EmailNotificationAdmin extends React.Component {
  getPlainTextFromHtml = (value = '') => value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
  hasInlineImage = (value = '') => /<img[\s\S]*?>/i.test(value);

  submitEmailNotification = () => {
    const { emailNotificationForm, sendBulkEmail, clearEmailNotificationFields } = this.props;
    const reqObj = {
      subject: emailNotificationForm.subject || '',
      message: emailNotificationForm.message || '',
      userGroups: (emailNotificationForm.userTypes || []).map(item => item.value)
    };
    sendBulkEmail(reqObj);
    clearEmailNotificationFields();
  };

  shouldDisableSubmit = () => {
    const { emailNotificationForm } = this.props;
    const formattedMessage = emailNotificationForm && emailNotificationForm.message
      ? this.getPlainTextFromHtml(emailNotificationForm.message)
      : '';
    const hasImage = emailNotificationForm && emailNotificationForm.message
      ? this.hasInlineImage(emailNotificationForm.message)
      : false;
    return !(
      emailNotificationForm
      && emailNotificationForm.subject
      && (formattedMessage || hasImage)
      && Array.isArray(emailNotificationForm.userTypes)
      && emailNotificationForm.userTypes.length > 0
    );
  };

  render() {
    return (
      <div className="ncss-col-sm-12 p3-sm">
        <div className="ncss-col-sm-7 ncss-form-group p2-bottom-sm ncss-input-container">
          <H5 className="u-bold description pb2-sm">Subject: <span className="astericks">*</span></H5>
          <Field
            component={TextInput}
            name="subject"
            type="text"
            placeholder="Enter email subject"
          //  className="rsl-email-subject-input"
          />
        </div>
        <div className="ncss-col-sm-12 ncss-form-group p2-bottom-sm">
          <H5 className="u-bold description pb2-sm">Message: <span className="astericks">*</span></H5>
          <Field
            component={RichTextEditor}
            name="message"
            placeholder="Enter email message"
          />
        </div>
        <div className="ncss-col-sm-7 ncss-form-group p2-bottom-sm rsl-email-user-type-wrap">
          <H5 className="u-bold description pb2-sm">User Type: <span className="astericks">*</span></H5>
          <Field
            component={MultiSelect}
            name="userTypes"
            options={usertypes}
            placeholder="Select user types"
            containerClass="u-full-width"
          />
        </div>
        <div className="ncss-col-sm-12 align-left p2-top-sm">
          <Button
            className={`ncss-btn-primary-dark u-bold submit-button-enable trf-button-selected ${this.shouldDisableSubmit() ? 'disabled' : ''}`}
            onClick={() => {
              if (!this.shouldDisableSubmit()) {
                this.submitEmailNotification();
              }
            }}
          >
            SEND EMAIL
          </Button>
        </div>
      </div>
    );
  }
}

EmailNotificationAdmin.propTypes = {
  emailNotificationForm: PropTypes.object,
  sendBulkEmail: PropTypes.func,
  clearEmailNotificationFields: PropTypes.func
};

const mapStateToProps = state => ({
  emailNotificationForm: getFormValues('emailNotificationAdmin')(state)
});

const mapDispatchToProps = dispatch => ({
  sendBulkEmail: data => {
    dispatch(createServiceAction('sendBulkEmail', 'requested')({ formValues: data }));
  },
  clearEmailNotificationFields: () => {
    dispatch(reset('emailNotificationAdmin'));
  }
});

export default reduxForm({
  form: 'emailNotificationAdmin'
})(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EmailNotificationAdmin)
);
